<template>
  <div v-if="active">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Step',
  inject: [
    'addStep',
    'removeStep',
    'stepIsActive',
    'hasPreviousStep',
    'hasNextStep',
  ],
  provide() {
    return {
      hasPreviousStep: this.hasPreviousStep,
      hasNextStep: this.hasNextStep,
    }
  },
  props: {
    stepName: { type: String },
    stepIsolated: { type: Boolean, defaultValue: false },
    stepRequiredFields: { type: Array, optional: true },
  },
  computed: {
    active() {
      return this.stepIsActive(this)
    },
  },
  mounted() {
    this.addStep(this)
  },
  unmounted() {
    this.removeStep(this)
  },
  requiredFields() {
    return this.$attrs.stepRequiredFields || []
  },
}
</script>
